<template>
  <div id="app">
    <router-view />
    <!-- <Home></Home> -->
    <div class="mask" :style="{ height: scrollerHeight }" v-show="showLoading" ref="mask">
      <LoadingCSS class="mask_img"></LoadingCSS>
    </div>
  </div>
</template>

<script>
import LoadingCSS from './components/common/loading.vue'
// import Home from './views/home/Home.vue'

export default {
  data() {
    return {}
  },
  components: {
    LoadingCSS
    // Home
  },
  mounted() {
    // 这个获取接口有问题, 会导致进入系统卡卡的
    // this.handleUseIPGetAddress()
    const that = this
    window.addEventListener('unload', this.saveUserData) // 监听刷新时
    // 监听浏览器大小
    window.onresize = function () {
      const clientHeight = `${document.documentElement.clientHeight}`
      const clientWidth = `${document.documentElement.clientWidth}`
      that.$store.commit('set_clientHeight', clientHeight)
      that.$store.commit('set_clientWidth', clientWidth)
    }
    this.$store.commit('set_clientHeight', `${document.documentElement.clientHeight}`)
    this.$store.commit('set_clientWidth', `${document.documentElement.clientWidth}`)
  },
  methods: {
    // 根据ip获取地址（搜狐接口的地址不太对劲）
    async handleUseIPGetAddress() {
      const { data: res } = await this.$http.get('/json', {
        headers: {
          ipSearch: true
        }
      })
      this.$store.commit('set_ipAndAddress', { ip: res.ip, address: res.province + res.city })
    },
    // 获取及缓存IP地址、物理地址信息
    // async handleGetIpAndAddress() {
    //   // 获取IP地址，但是会被广告插件拦截
    //   const loadScript = src => {
    //     return new Promise(resolve => {
    //       const script = document.createElement('script')
    //       const head = document.getElementsByTagName('head')[0]
    //       script.type = 'text/javascript'
    //       script.charset = 'UTF-8'
    //       script.src = src
    //       if (script.addEventListener) {
    //         script.addEventListener(
    //           'load',
    //           function () {
    //             resolve()
    //           },
    //           false
    //         )
    //       } else if (script.attachEvent) {
    //         script.attachEvent('onreadystatechange', function () {
    //           const target = window.event.srcElement
    //           if (target.readyState == 'loaded') {
    //             resolve()
    //           }
    //         })
    //       }
    //       head.appendChild(script)
    //     })
    //   }
    //   await loadScript(`http://pv.sohu.com/cityjson?ie=utf-8`)
    //   if (!this.$store.state.ipAndAddress.ip) {
    //     this.$store.commit('set_ipAndAddress', {
    //       ip: window.returnCitySN['cip'],
    //       address: window.returnCitySN['cname']
    //     })
    //   }
    // },
    saveUserData() {
      this.$store.dispatch('shutloader')
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    }
  },
  computed: {
    scrollerHeight() {
      return this.$store.state.clientHeight + 'px'
    },
    showLoading() {
      return this.$store.state.showLoading > 0
    }
  }
}
</script>
<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  color: white;
}
.mask_img {
  z-index: 99999;
  position: fixed;
  left: 50%;
  top: 50%;
}
#vxeDelete {
  color: red;
}
</style>
